var map = {
	"./01_get_contract_allPosition.json": "IW/r",
	"./02_get_contract_allOrders.json": "y5ws",
	"./03_get_contract_balance.json": "smla"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "h5iU";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/standard/api/trade \.json$
// module id = h5iU
// module chunks = 3